import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Button, ButtonGroup, Card, CardBody, Col, Input, Row, Table } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import DebounceInput from "react-debounce-input";
import { toast } from "react-toastify";
import Select from "react-select";
import { useGetItemClasses } from "../hooks";
import { DesktopContainer } from "../layouts";
import { api, constants, dateHelpers, helpers } from "../utils";
import { ItemDropdownMenu, ItemTypeahead, ServiceThreadSpinner, SortHeader, VendorTypeahead } from "./";

const RadioButttonTypes = {
   All: 1,
   OVER: 2,
   UNDER: 3
};

const today = new Date();
const thisMonth = today.getMonth() + 1;
const thisDay = today.getDate();
const thisYear = today.getFullYear();
const lastWk = dateHelpers.addDays(today, -7);
const lastMth = lastWk.getMonth() + 1;
const lastDay = lastWk.getDate();
const lastYr = lastWk.getFullYear();
const startDate = `${lastMth}/${lastDay}/${lastYr}`;
const endDate = `${thisMonth}/${thisDay}/${thisYear}`;

export default function RawMaterialUsage(props) {
   const cancelToken = axios.CancelToken;
   const source = cancelToken.source();
   const ClassList = useGetItemClasses({ IsPurchasedMaterial: true });
   const [filters, setFilters] = useState({
      sortDirection: "asc",
      sortField: "",
   });
   const [screenFields, setScreenFields] = useState({
      screenItems: [],
      payload: {
         itemOrder: 1,
         startDate: dateHelpers.formatDateForServer(startDate),
         endDate: dateHelpers.formatDateForServer(endDate),
         classCode: [],
         vendor: null,
         itemNumberChecked: true,
         itemDescriptionPartialChecked: false,
         itemNumber: "",
         itemDescriptionPartial: "",
         sortDirection: "",
         sortField: "",
      },
      onHandTotal: 0,
      onOrderTotal: 0,
      year1: 0,
      year2: 0,
      year4: 0,
      year5: 0,
      year6: 0,
      year7: 0,
      year8: 0,
      year9: 0,
      year10: 0,
      year11: 0,
      year12: 0,
      usageTotal: 0,
      usageAvgTotal: 0
   });
   const [downloading, setDownloading] = useState(false);
   const [isLoading, setIsLoading] = useState(false);

   useEffect(() => {
      if (!ClassList.Success) return;
      LoadTable();
      return () => {
         source.cancel("axios request cancelled");
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [filters, ClassList]);

   function CreatePayload() {
      const classListVar = getCommaDelimitedString(screenFields.payload.classCode);
      if (typeof classListVar !== "string") {
         toast.error("incorrect classlist format")
      }
      let copy = _.cloneDeep(screenFields);
      let extPayload = _.set(copy, 'payload.classCode', classListVar);
      let payload = Object.assign({
         ItemDescription: screenFields.payload.itemDescriptionPartial,
         VendorId: screenFields.payload.vendor ? screenFields.payload.vendor.value : screenFields.payload.vendor,
         ItemNumber: screenFields.payload.itemNumber?.value
      }, { ...extPayload.payload, ...filters });
      delete payload.itemNumber
      return payload;
   }

   const getCommaDelimitedString = (list) => {
      if (!ClassList.Success) {
         toast.error("racing issue");
         return;
      }
      if (_.isEmpty(list)) list = ClassList.ClassList;

      let result = "";
      _.map(list, (x) => {
         if (typeof x.value === "string") {
            result += `${x.value.trim()},`;
         }
      });
      result = result.slice(0, -1);
      return result;
   };

   const LoadTable = () => {
      setIsLoading(true);
      let pay = CreatePayload();
      if (new Date(pay.endDate) < new Date(pay.startDate)) {
         toast.error("End date cannot be prior to start date!");
         setIsLoading(false);
         return;
      }

      api.postS("Purchasing/RawMaterial", pay, source.token).then(
         (response) => {
            if (response.data?.success) {
               if (response.data.rawMaterialUsage.length) {
                  const copy = _.cloneDeep(screenFields);
                  const data = response.data?.rawMaterialUsage;
                  _.map(data, x => {
                     if (x.dailyAvg === -0) x.dailyAvg = 0;
                     return x;
                  });
                  const row1 = data[0];
                  const TotalMonthsAdd = _.chain(row1).pickBy((v, k) => _.includes(k, "year") && v !== "0").keys().value().length;
                  const TotalUsage = data.reduce((total, currentElement) => (total = total + currentElement.itemTotal), 0);
                  //count the total months
                  setScreenFields({
                     ...copy,
                     rowOne: row1,
                     screenItems: data,
                     onHandTotal: data.reduce((total, currentElement) => (total = total + currentElement.onHand), 0),
                     onOrderTotal: data.reduce((total, currentElement) => (total = total + currentElement.onOrder), 0),
                     usageTotal: TotalUsage,
                     usageAvgTotal: TotalMonthsAdd >= 1 ? (TotalUsage / TotalMonthsAdd) : 0,
                     year1: row1.year1 !== "0" ? data.reduce((total, currentElement) => (total = total + currentElement.qty1), 0) : 0,
                     year2: row1.year2 !== "0" ? data.reduce((total, currentElement) => (total = total + currentElement.qty2), 0) : 0,
                     year3: row1.year3 !== "0" ? data.reduce((total, currentElement) => (total = total + currentElement.qty3), 0) : 0,
                     year4: row1.year4 !== "0" ? data.reduce((total, currentElement) => (total = total + currentElement.qty4), 0) : 0,
                     year5: row1.year5 !== "0" ? data.reduce((total, currentElement) => (total = total + currentElement.qty5), 0) : 0,
                     year6: row1.year6 !== "0" ? data.reduce((total, currentElement) => (total = total + currentElement.qty6), 0) : 0,
                     year7: row1.year7 !== "0" ? data.reduce((total, currentElement) => (total = total + currentElement.qty7), 0) : 0,
                     year8: row1.year8 !== "0" ? data.reduce((total, currentElement) => (total = total + currentElement.qty8), 0) : 0,
                     year9: row1.year9 !== "0" ? data.reduce((total, currentElement) => (total = total + currentElement.qty9), 0) : 0,
                     year10: row1.year10 !== "0" ? data.reduce((total, currentElement) => (total = total + currentElement.qty10), 0) : 0,
                     year11: row1.year11 !== "0" ? data.reduce((total, currentElement) => (total = total + currentElement.qty11), 0) : 0,
                     year12: row1.year12 !== "0" ? data.reduce((total, currentElement) => (total = total + currentElement.qty12), 0) : 0,
                  })
               } else {
                  setScreenFields({
                     ...screenFields,
                     screenItems: []
                  })
               }
            } else {
               throw new Error(response)
            }
         }
      ).catch(api.catchHandler)
       .finally(() => { setIsLoading(false) })
   }

   const onChange = (property, value, copy = null) => {
      if (copy === null) copy = _.cloneDeep(screenFields);
      _.set(copy, property, value);
      setScreenFields(copy);
      return;
   };

   const onExportToXlsx = () => {
      setDownloading(true)
      const payload = CreatePayload()
      if (new Date(payload.endDate) < new Date(payload.startDate)) {
         toast.error("End date cannot be prior to start date!");
         setDownloading(false);
         return;
      }

      api
         .postGetBlob("Purchasing/ExportRawUsageMaterialXLSX", payload)
         .then(r => {
            if (r.data.success === false) {
               if (_.isString(r.data.message)) {
                  toast.error(r.data.message);
               }
               return;
            }
            if (r.data) {
               const XLSX_FILENAME = `RawMaterialUsageHistory.xlsx`
               helpers.downloadExport(r.data, XLSX_FILENAME, constants.MIME_TYPES.xlsx)
            } else {
               toast.error(r.message || "There was an error downloading the invoice history");
            }
         }).catch((error) => {
            api.catchHandler(error)
            toast.error("There was an error downloading the invoice history");
         })
         .finally(() => setDownloading(false));
   }

   const onFilterChange = (newFilters) => {
      setFilters(newFilters);
   }

   const RadioButtonTypeAhead = (currentValue, PropertyToBecomeTrue, PropertyToBecomeFalse, PropertyToBecomeNull) => {
      if (currentValue) return; // no need to switch it is already true
      const copy = _.cloneDeep(screenFields);
      _.set(copy, PropertyToBecomeTrue, true);
      _.set(copy, PropertyToBecomeFalse, false);
      _.set(copy, PropertyToBecomeNull, "");
      setScreenFields(copy);
   }

   return (
      document.title = `Raw Material Usage History`,
      <DesktopContainer screenName={"Raw Material Usage History"}>
         <div className="filter-header">
            <Row className="mt-3">
               <Col xs="3" className="text-end">
                  <h5 className="pt-1 text-white">Start Date:</h5>
               </Col>
               <Col xs="6">
                  <DebounceInput
                     type="date"
                     onChange={(e) => onChange("payload.startDate", e.target.value)}
                     value={dateHelpers.formatDateForServer(startDate)}
                     debounceTimeout={500}
                  />
               </Col>
            </Row>

            <Row className="mt-3">
               <Col xs="3" className="text-end">
                  <h5 className="pt-1 text-white">End Date:</h5>
               </Col>
               <Col xs="6">
                  <DebounceInput
                     type="date"
                     onChange={(e) => onChange("payload.endDate", e.target.value)}
                     value={dateHelpers.formatDateForServer(endDate)}
                     debounceTimeout={500}
                  />
               </Col>
            </Row>

            <Row className="mt-3">
               <Col xs="3" className="text-end">
                  <h5 className="pt-1 text-white">Item Number:</h5>
               </Col>
               <Col xs="1" style={{ paddingRight: "0px" }}>
                  <Input
                     type="checkbox"
                     name={"ItemNumber"}
                     checked={screenFields.payload.itemNumberChecked}
                     onChange={() => RadioButtonTypeAhead(
                        screenFields.payload.itemNumberChecked,
                        "payload.itemNumberChecked",
                        "payload.itemDescriptionPartialChecked",
                        "payload.itemDescriptionPartial")}
                  />
               </Col>
               {screenFields.payload.itemNumberChecked &&
                  <>
                     <Col xs="4">
                        <ItemTypeahead
                           value={screenFields.payload.itemNumber}
                           onChange={(opt) => onChange("payload.itemNumber", opt)}
                        />
                     </Col>
                     <Col xs="4"></Col>
                  </>
               }
            </Row>

            <Row className="mt-2">
               <Col xs="3" className="text-end">
                  <h5 className="pt-1 text-white">Item Description Partial:</h5>
               </Col>
               <Col xs="1" style={{ paddingRight: "0px" }}>
                  <Input
                     type="checkbox"
                     name={"ItemDescriptionPartial"}
                     checked={screenFields.payload.itemDescriptionPartialChecked}
                     onChange={() => RadioButtonTypeAhead(
                        screenFields.payload.itemDescriptionPartialChecked,
                        "payload.itemDescriptionPartialChecked",
                        "payload.itemNumberChecked",
                        "payload.itemNumber")}
                  />
               </Col>
               {screenFields.payload.itemDescriptionPartialChecked &&
                  <Col xs="4">
                     <Input
                        type="text"
                        name={"ItemDescriptionPartial"}
                        value={screenFields.payload.itemDescriptionPartial}
                        onChange={(e) => {
                           onChange("payload.itemDescriptionPartial", e.target.value);
                        }}
                     />
                  </Col>
               }
            </Row>

            <Row xs="" className="mt-3">
               <Col xs="3" className="text-end">
                  <h5 className="pt-1 text-white">Vendor:</h5>
               </Col>
               <Col xs="6">
                  <VendorTypeahead
                     value={screenFields.payload.vendor}
                     onChange={(opt) => onChange("payload.vendor", opt)}
                  />
               </Col>
            </Row>

            <Row xs="" className="mt-3">
               <Col xs="3" className="text-end">
                  <h5 className="pt-1 text-white">Class:</h5>
               </Col>
               <Col xs="6">
                  <Select
                     classNamePrefix="serviceThreadSelect"
                     options={ClassList.ClassList}
                     value={screenFields.payload.classCode}
                     onChange={(opt) => onChange("payload.classCode", opt)}
                     isMulti={true}
                     isClearable={true}
                  />
               </Col>
            </Row>

            <Row className="mt-3">
               <Col>
                  <Row>
                     <Col xs="3"></Col>
                     <Col>
                        <input
                           type="radio"
                           id="All"
                           name="itemOrder"
                           defaultChecked={true}
                           onChange={() => onChange("payload.itemOrder", RadioButttonTypes.All)}
                        />
                        &nbsp;<label className="text-white">All</label>
                     </Col>
                     <Col>
                        <input
                           type="radio"
                           id="Over"
                           name="itemOrder"
                           onChange={() => onChange("payload.itemOrder", RadioButttonTypes.OVER)}
                        />
                        &nbsp;<label className="text-white">Over</label>
                     </Col>
                     <Col>
                        <input
                           type="radio"
                           id="Under"
                           name="itemOrder"
                           onChange={() => onChange("payload.itemOrder", RadioButttonTypes.UNDER)}
                        />
                        &nbsp;<label className="text-white">Under</label>
                     </Col>
                     <Col xs="6"></Col>
                  </Row>
               </Col>
            </Row>

            <Row className="mt-3">
               <Col xs="3"></Col>
               <Col>
                  <Button className="shredButton" onClick={LoadTable} disabled={isLoading}>SHOW RAW MATERIAL USAGE</Button>
               </Col>
            </Row>
         </div>

         <Card className="dashboard-card">
            <CardBody>
               <ServiceThreadSpinner on={isLoading}>
                  {screenFields && screenFields.screenItems?.length ?
                     <>
                        <Row className="align-items-center mb-2">
                           <Col className="transparent-background">
                              <ButtonGroup className="float-end">
                                 <Button
                                    title="Download as .xlsx"
                                    className="shredButtonExcel float-end ms-2"
                                    onClick={onExportToXlsx}
                                    disabled={downloading}
                                 >
                                    <FontAwesomeIcon icon="file-excel" size="lg" />
                                 </Button>
                              </ButtonGroup>
                           </Col>
                        </Row>
                        <Table size="sm" className="data-table">
                           <thead className="table-header">
                              <tr>
                                 <th>
                                    <SortHeader
                                       displayName={"Item"}
                                       field={"itemNumber"}
                                       sortDirection={filters.sortDirection}
                                       sorted={filters.sortField === "ItemNumber"}
                                       callback={onFilterChange}
                                       state={{
                                          sortField: "ItemNumber",
                                          sortDirection: filters.sortDirection === "asc"
                                             ? "desc"
                                             : "asc"
                                       }}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={"Vendor"}
                                       field={"vendor"}
                                       sortDirection={filters.sortDirection}
                                       sorted={filters.sortField === "Vendor"}
                                       callback={onFilterChange}
                                       state={{
                                          sortField: "Vendor",
                                          sortDirection: filters.sortDirection === "asc"
                                             ? "desc"
                                             : "asc"
                                       }}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={"Total On Hand"}
                                       field={"onHand"}
                                       sortDirection={filters.sortDirection}
                                       sorted={filters.sortField === "OnHand"}
                                       callback={onFilterChange}
                                       state={{
                                          sortField: "OnHand",
                                          sortDirection: filters.sortDirection === "asc"
                                             ? "desc"
                                             : "asc"
                                       }}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={"Qty In-Transit"}
                                       field={"qtyInTransit"}
                                       sortDirection={filters.sortDirection}
                                       sorted={filters.sortField === "QtyInTransit"}
                                       callback={onFilterChange}
                                       state={{
                                          sortField: "QtyInTransit",
                                          sortDirection: filters.sortDirection === "asc"
                                             ? "desc"
                                             : "asc"
                                       }}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={"Order Point"}
                                       field={"orderPoint"}
                                       sortDirection={filters.sortDirection}
                                       sorted={filters.sortField === "OrderPoint"}
                                       callback={onFilterChange}
                                       state={{
                                          sortField: "OrderPoint",
                                          sortDirection: filters.sortDirection === "asc"
                                             ? "desc"
                                             : "asc"
                                       }}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={"On Order Qty"}
                                       field={"onOrder"}
                                       sortDirection={filters.sortDirection}
                                       sorted={filters.sortField === "OnOrder"}
                                       callback={onFilterChange}
                                       state={{
                                          sortField: "OnOrder",
                                          sortDirection: filters.sortDirection === "asc"
                                             ? "desc"
                                             : "asc"
                                       }}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={"Lead Time"}
                                       field={"avgLeadTime"}
                                       sortDirection={filters.sortDirection}
                                       sorted={filters.sortField === "AvgLeadTime"}
                                       callback={onFilterChange}
                                       state={{
                                          sortField: "AvgLeadTime",
                                          sortDirection: filters.sortDirection === "asc"
                                             ? "desc"
                                             : "asc"
                                       }}
                                    />
                                 </th>
                                 {screenFields.rowOne?.year1 !== "0" ?
                                    <th>
                                       <SortHeader
                                          displayName={
                                             <span>
                                                {screenFields.rowOne?.year1}
                                                <br />
                                                {screenFields.rowOne?.month1}
                                             </span>
                                          }
                                          field={"month1"}
                                          sortDirection={filters.sortDirection}
                                          sorted={filters.sortField === "Qty1"}
                                          callback={onFilterChange}
                                          state={{
                                             sortField: "Qty1",
                                             sortDirection: filters.sortDirection === "asc"
                                                ? "desc"
                                                : "asc"
                                          }}
                                       />
                                    </th>
                                    : null
                                 }
                                 {screenFields.rowOne?.year2 !== "0" ?
                                    <th>
                                       <SortHeader
                                          displayName={
                                             <span>
                                                {screenFields.rowOne?.year2}
                                                <br />
                                                {screenFields.rowOne?.month2}
                                             </span>
                                          }
                                          field={"month2"}
                                          sortDirection={filters.sortDirection}
                                          sorted={filters.sortField === "Qty2"}
                                          callback={onFilterChange}
                                          state={{
                                             sortField: "Qty2",
                                             sortDirection: filters.sortDirection === "asc"
                                                ? "desc"
                                                : "asc"
                                          }}
                                       />
                                    </th>
                                    : null
                                 }
                                 {screenFields.rowOne?.year3 !== "0" ?
                                    <th>
                                       <SortHeader
                                          displayName={
                                             <span>
                                                {screenFields.rowOne?.year3}
                                                <br />
                                                {screenFields.rowOne?.month3}
                                             </span>
                                          }
                                          field={"month3"}
                                          sortDirection={filters.sortDirection}
                                          sorted={filters.sortField === "Qty3"}
                                          callback={onFilterChange}
                                          state={{
                                             sortField: "Qty3",
                                             sortDirection: filters.sortDirection === "asc"
                                                ? "desc"
                                                : "asc"
                                          }}
                                       />
                                    </th>
                                    : null
                                 }
                                 {screenFields.rowOne?.year4 !== "0" ?
                                    <th>
                                       <SortHeader
                                          displayName={
                                             <span>
                                                {screenFields.rowOne?.year4}
                                                <br />
                                                {screenFields.rowOne?.month4}
                                             </span>
                                          }
                                          field={"month4"}
                                          sortDirection={filters.sortDirection}
                                          sorted={filters.sortField === "Qty4"}
                                          callback={onFilterChange}
                                          state={{
                                             sortField: "Qty4",
                                             sortDirection: filters.sortDirection === "asc"
                                                ? "desc"
                                                : "asc"
                                          }}
                                       />
                                    </th>
                                    : null
                                 }
                                 {screenFields.rowOne?.year5 !== "0" ?
                                    <th>
                                       <SortHeader
                                          displayName={
                                             <span>
                                                {screenFields.rowOne?.year5}
                                                <br />
                                                {screenFields.rowOne?.month5}
                                             </span>
                                          }
                                          field={"month5"}
                                          sortDirection={filters.sortDirection}
                                          sorted={filters.sortField === "Qty5"}
                                          callback={onFilterChange}
                                          state={{
                                             sortField: "Qty5",
                                             sortDirection: filters.sortDirection === "asc"
                                                ? "desc"
                                                : "asc"
                                          }}
                                       />
                                    </th>
                                    : null
                                 }
                                 {screenFields.rowOne?.year6 !== "0" ?
                                    <th>
                                       <SortHeader
                                          displayName={
                                             <span>
                                                {screenFields.rowOne?.year6}
                                                <br />
                                                {screenFields.rowOne?.month6}
                                             </span>
                                          }
                                          field={"month6"}
                                          sortDirection={filters.sortDirection}
                                          sorted={filters.sortField === "Qty6"}
                                          callback={onFilterChange}
                                          state={{
                                             sortField: "Qty6",
                                             sortDirection: filters.sortDirection === "asc"
                                                ? "desc"
                                                : "asc"
                                          }}
                                       />
                                    </th>
                                    : null
                                 }
                                 {screenFields.rowOne?.year7 !== "0" ?
                                    <th>
                                       <SortHeader
                                          displayName={
                                             <span>
                                                {screenFields.rowOne?.year7}
                                                <br />
                                                {screenFields.rowOne?.month7}
                                             </span>
                                          }
                                          field={"month7"}
                                          sortDirection={filters.sortDirection}
                                          sorted={filters.sortField === "Qty7"}
                                          callback={onFilterChange}
                                          state={{
                                             sortField: "Qty7",
                                             sortDirection: filters.sortDirection === "asc"
                                                ? "desc"
                                                : "asc"
                                          }}
                                       />
                                    </th>
                                    : null
                                 }
                                 {screenFields.rowOne?.year8 !== "0" ?
                                    <th>
                                       <SortHeader
                                          displayName={
                                             <span>
                                                {screenFields.rowOne?.year8}
                                                <br />
                                                {screenFields.rowOne?.month8}
                                             </span>
                                          }
                                          field={"month8"}
                                          sortDirection={filters.sortDirection}
                                          sorted={filters.sortField === "Qty8"}
                                          callback={onFilterChange}
                                          state={{
                                             sortField: "Qty8",
                                             sortDirection: filters.sortDirection === "asc"
                                                ? "desc"
                                                : "asc"
                                          }}
                                       />
                                    </th>
                                    : null
                                 }
                                 {screenFields.rowOne?.year9 !== "0" ?
                                    <th>
                                       <SortHeader
                                          displayName={
                                             <span>
                                                {screenFields.rowOne?.year9}
                                                <br />
                                                {screenFields.rowOne?.month9}
                                             </span>
                                          }
                                          field={"month9"}
                                          sortDirection={filters.sortDirection}
                                          sorted={filters.sortField === "Qty9"}
                                          callback={onFilterChange}
                                          state={{
                                             sortField: "Qty9",
                                             sortDirection: filters.sortDirection === "asc"
                                                ? "desc"
                                                : "asc"
                                          }}
                                       />
                                    </th>
                                    : null
                                 }
                                 {screenFields.rowOne?.year10 !== "0" ?
                                    <th>
                                       <SortHeader
                                          displayName={
                                             <span>
                                                {screenFields.rowOne?.year10}
                                                <br />
                                                {screenFields.rowOne?.month10}
                                             </span>
                                          }
                                          field={"month10"}
                                          sortDirection={filters.sortDirection}
                                          sorted={filters.sortField === "Qty10"}
                                          callback={onFilterChange}
                                          state={{
                                             sortField: "Qty10",
                                             sortDirection: filters.sortDirection === "asc"
                                                ? "desc"
                                                : "asc"
                                          }}
                                       />
                                    </th>
                                    : null
                                 }
                                 {screenFields.rowOne?.year11 !== "0" ?
                                    <th>
                                       <SortHeader
                                          displayName={
                                             <span>
                                                {screenFields.rowOne?.year11}
                                                <br />
                                                {screenFields.rowOne?.month11}
                                             </span>
                                          }
                                          field={"month11"}
                                          sortDirection={filters.sortDirection}
                                          sorted={filters.sortField === "Qty11"}
                                          callback={onFilterChange}
                                          state={{
                                             sortField: "Qty11",
                                             sortDirection: filters.sortDirection === "asc"
                                                ? "desc"
                                                : "asc"
                                          }}
                                       />
                                    </th>
                                    : null
                                 }
                                 {screenFields.rowOne?.year12 !== "0" ?
                                    <th>
                                       <SortHeader
                                          displayName={
                                             <span>
                                                {screenFields.rowOne?.year12}
                                                <br />
                                                {screenFields.rowOne?.month12}
                                             </span>
                                          }
                                          field={"month12"}
                                          sortDirection={filters.sortDirection}
                                          sorted={filters.sortField === "Qty12"}
                                          callback={onFilterChange}
                                          state={{
                                             sortField: "Qty12",
                                             sortDirection: filters.sortDirection === "asc"
                                                ? "desc"
                                                : "asc"
                                          }}
                                       />
                                    </th>
                                    : null
                                 }
                                 <th>
                                    <SortHeader
                                       displayName={"Total"}
                                       field={"itemTotal"}
                                       sortDirection={filters.sortDirection}
                                       sorted={filters.sortField === "ItemTotal"}
                                       callback={onFilterChange}
                                       state={{
                                          sortField: "ItemTotal",
                                          sortDirection: filters.sortDirection === "asc"
                                             ? "desc"
                                             : "asc"
                                       }}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={"Montly Average"}
                                       field={"itemAvg"}
                                       sortDirection={filters.sortDirection}
                                       sorted={filters.sortField === "ItemAvg"}
                                       callback={onFilterChange}
                                       state={{
                                          sortField: "ItemAvg",
                                          sortDirection: filters.sortDirection === "asc"
                                             ? "desc"
                                             : "asc"
                                       }}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={"Daily Avg (lbs)"}
                                       field={"dailyAvg"}
                                       sortDirection={filters.sortDirection}
                                       sorted={filters.sortField === "DailyAvg"}
                                       callback={onFilterChange}
                                       state={{
                                          sortField: "DailyAvg",
                                          sortDirection: filters.sortDirection === "asc"
                                             ? "desc"
                                             : "asc"
                                       }}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={"Days On Hand"}
                                       field={"daysOnHand"}
                                       sortDirection={filters.sortDirection}
                                       sorted={filters.sortField === "DaysOnHand"}
                                       callback={onFilterChange}
                                       state={{
                                          sortField: "DaysOnHand",
                                          sortDirection: filters.sortDirection === "asc"
                                             ? "desc"
                                             : "asc"
                                       }}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={"Over/Under"}
                                       field={"overUnderAmountString"}
                                       sortDirection={filters.sortDirection}
                                       sorted={filters.sortField === "OverUnderAmount"}
                                       callback={onFilterChange}
                                       state={{
                                          sortField: "OverUnderAmount",
                                          sortDirection: filters.sortDirection === "asc"
                                             ? "desc"
                                             : "asc"
                                       }}
                                    />
                                 </th>
                              </tr>
                           </thead>
                           <tbody>
                              {_.map(screenFields.screenItems, (datum, index) => {
                                 return (
                                    <tr key={index} className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}>
                                       <ItemDropdownMenu
                                          itemNumber={datum.itemNumber}
                                          itemDescription={_.trim(datum.itemWithDesc)}
                                          attachmentCount={datum.attachmentCount}
                                       />
                                       <td>{datum.vendor}</td>
                                       <td>{Math.round(datum.onHand).toLocaleString()}</td> {/*Total*/}
                                       <td>{Math.round(datum.qtyInTransit).toLocaleString()}</td>
                                       <td>{Math.round(datum.orderPoint).toLocaleString()}</td>
                                       <td>{Math.round(datum.onOrder)}</td> {/*Total*/}
                                       <td>{datum.avgLeadTime}</td>
                                       {screenFields.rowOne?.year1 !== "0"
                                          ? <td>{Math.round(datum.qty1).toLocaleString()}</td>
                                          : null}
                                       {screenFields.rowOne?.year2 !== "0"
                                          ? <td>{Math.round(datum.qty2).toLocaleString()}</td>
                                          : null}
                                       {screenFields.rowOne?.year3 !== "0"
                                          ? <td>{Math.round(datum.qty3).toLocaleString()}</td>
                                          : null}
                                       {screenFields.rowOne?.year4 !== "0"
                                          ? <td>{Math.round(datum.qty4).toLocaleString()}</td>
                                          : null}
                                       {screenFields.rowOne?.year5 !== "0"
                                          ? <td>{Math.round(datum.qty5).toLocaleString()}</td>
                                          : null}
                                       {screenFields.rowOne?.year6 !== "0"
                                          ? <td>{Math.round(datum.qty6).toLocaleString()}</td>
                                          : null}
                                       {screenFields.rowOne?.year7 !== "0"
                                          ? <td>{Math.round(datum.qty7).toLocaleString()}</td>
                                          : null}
                                       {screenFields.rowOne?.year8 !== "0"
                                          ? <td>{Math.round(datum.qty8).toLocaleString()}</td>
                                          : null}
                                       {screenFields.rowOne?.year9 !== "0"
                                          ? <td>{Math.round(datum.qty9).toLocaleString()}</td>
                                          : null}
                                       {screenFields.rowOne?.year10 !== "0"
                                          ? <td>{Math.round(datum.qty10).toLocaleString()}</td>
                                          : null}
                                       {screenFields.rowOne?.year11 !== "0"
                                          ? <td>{Math.round(datum.qty11).toLocaleString()}</td>
                                          : null}
                                       {screenFields.rowOne?.year12 !== "0"
                                          ? <td>{Math.round(datum.qty12).toLocaleString()}</td>
                                          : null}
                                       <td>{Math.round(datum.itemTotal).toLocaleString()}</td>
                                       <td>{Math.round(datum.itemAvg).toLocaleString()}</td>
                                       <td>{Math.round(datum.dailyAvg).toLocaleString()}</td>
                                       <td>{Math.round(datum.daysOnHand).toLocaleString()}</td>
                                       <td>{datum.overUnderAmountString}</td>
                                    </tr>
                                 )
                              })}
                           </tbody>
                           <tfoot className="table-footer">
                              <tr>
                                 <td colSpan={2} />
                                 <td className="fw-bold" children={Math.round(screenFields.onHandTotal).toLocaleString()} />
                                 <td colSpan={2} />
                                 <td className="fw-bold" children={Math.round(screenFields.onOrderTotal).toLocaleString()} />
                                 <td colSpan={1} />
                                 {screenFields.rowOne?.year1 === "0" ? null : <td className="fw-bold" children={Math.round(screenFields.year1).toLocaleString()} />}
                                 {screenFields.rowOne?.year2 === "0" ? null : <td className="fw-bold" children={Math.round(screenFields.year2).toLocaleString()} />}
                                 {screenFields.rowOne?.year3 === "0" ? null : <td className="fw-bold" children={Math.round(screenFields.year3).toLocaleString()} />}
                                 {screenFields.rowOne?.year4 === "0" ? null : <td className="fw-bold" children={Math.round(screenFields.year4).toLocaleString()} />}
                                 {screenFields.rowOne?.year5 === "0" ? null : <td className="fw-bold" children={Math.round(screenFields.year5).toLocaleString()} />}
                                 {screenFields.rowOne?.year6 === "0" ? null : <td className="fw-bold" children={Math.round(screenFields.year6).toLocaleString()} />}
                                 {screenFields.rowOne?.year7 === "0" ? null : <td className="fw-bold" children={Math.round(screenFields.year7).toLocaleString()} />}
                                 {screenFields.rowOne?.year8 === "0" ? null : <td className="fw-bold" children={Math.round(screenFields.year8).toLocaleString()} />}
                                 {screenFields.rowOne?.year9 === "0" ? null : <td className="fw-bold" children={Math.round(screenFields.year9).toLocaleString()} />}
                                 {screenFields.rowOne?.year10 === "0" ? null : <td className="fw-bold" children={Math.round(screenFields.year10).toLocaleString()} />}
                                 {screenFields.rowOne?.year11 === "0" ? null : <td className="fw-bold" children={Math.round(screenFields.year11).toLocaleString()} />}
                                 {screenFields.rowOne?.year12 === "0" ? null : <td className="fw-bold" children={Math.round(screenFields.year12).toLocaleString()} />}
                                 <td className="fw-bold" children={Math.round(screenFields.usageTotal).toLocaleString()} />
                                 <td className="fw-bold" children={Math.round(screenFields.usageAvgTotal).toLocaleString()} />
                                 <td colSpan={3} />
                              </tr>
                           </tfoot>
                        </Table>
                     </>
                     : <div className="mt-5" style={{ textAlign: "center" }}>
                        <span>Results Not Found</span>
                     </div>
                  }
               </ServiceThreadSpinner>
            </CardBody>
         </Card>
      </DesktopContainer>
   );
}
